module.exports = __webpack_public_path__ + "img/red_clay.09207a39.jpeg";